import React from 'react';

const TestPage = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Test Page</h1>
      <p className="mb-4">Current URL: {window.location.href}</p>
      <p className="mb-4">Current Path: {window.location.pathname}</p>
      <p className="mb-4">Current Search: {window.location.search}</p>
      <p className="mb-4">Current Hash: {window.location.hash}</p>
      
      <div className="space-y-2">
        <h2 className="text-lg font-semibold">Test Navigation:</h2>
        <button 
          onClick={() => window.location.href = '/#/dashboard'}
          className="block bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Go to Dashboard
        </button>
        <button 
          onClick={() => window.location.href = '/#/carts'}
          className="block bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
        >
          Go to Carts
        </button>
        <button 
          onClick={() => window.location.reload()}
          className="block bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
        >
          Refresh This Page
        </button>
      </div>
    </div>
  );
};

export default TestPage;
